import { Phone, Mail, MapPin, Building2 } from "lucide-react";
import Reveal from "../components/Reveal";
import RfqForm from "../components/RfqForm";
import { PageBanner } from "./About";

const Contact = () => (
  <>
    <PageBanner
      testId="contact-banner"
      eyebrow="Contact / Request a Quote"
      title="Contact Radiant Machine Tools"
      description="Send us your drawing or technical specification and our team will review your requirement and respond with a quotation."
    />

    <section data-testid="contact-section" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2 space-y-6">
          <Reveal>
            <div className="border border-slate-200 bg-white p-6 rounded-sm">
              <h2 className="text-lg font-semibold text-slate-900">Company Details</h2>
              <ul className="mt-5 space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <Building2 size={16} className="mt-0.5 text-[#2563EB] shrink-0" />
                  <span className="text-slate-700 font-medium">Radiant Machine Tools</span>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin size={16} className="mt-0.5 text-[#2563EB] shrink-0" />
                  <span data-testid="contact-location" className="text-slate-600">
                    B-26/4, Ancillary Industrial Estate, BHEL,<br />
                    Ramachandrapuram, Hyderabad, Telangana 502032
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Phone size={16} className="mt-0.5 text-[#2563EB] shrink-0" />
                  <a href="tel:+919440080160" data-testid="contact-phone" className="text-slate-600 hover:text-[#2563EB] transition-colors">
                    +91 94400 80160
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Mail size={16} className="mt-0.5 text-[#2563EB] shrink-0" />
                  <a href="mailto:sales@radiantmachinetools.com" data-testid="contact-email" className="text-slate-600 hover:text-[#2563EB] transition-colors">
                    sales@radiantmachinetools.com
                  </a>
                </li>
              </ul>
              <p className="mt-5 text-xs text-slate-500 leading-relaxed">
                For quotations, call or email us directly — or submit the enquiry form and our
                team will review your requirement and get back to you.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.08}>
            <div className="border border-slate-200 rounded-sm overflow-hidden">
              <iframe
                title="Radiant Machine Tools location — B-26/4, Ancillary Industrial Estate, BHEL, Ramachandrapuram, Hyderabad"
                data-testid="location-map"
                src="https://maps.google.com/maps?q=B-26%2F4,+Ancillary+Industrial+Estate,+BHEL,+Ramachandrapuram,+Hyderabad,+Telangana+502032&z=15&output=embed"
                className="w-full aspect-[4/3] border-0"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-3">
          <Reveal delay={0.05}>
            <RfqForm />
          </Reveal>
        </div>
      </div>
    </section>
  </>
);

export default Contact;
